// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__xG850","message":"message__XLaOL","actions":"actions__k6EeK","btn-submit":"btn-submit__y9oaZ","root":"root__bTJO5"};